<div class="modal-header">
  <h5 class="modal-title">Select Columns</h5>
  <button type="button" class="btn-close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <div class="row">
    <ng-container *ngFor="let col of data">
        <div class="col-3 mb-2" *ngIf="!col.locked">
            <div class="form-check">
                <input 
                type="checkbox" 
                class="form-check-input"
                [(ngModel)]="col.visible"
                (click)="toggle(col)" />
                <label class="form-check-label">{{ col.label }}</label>
            </div>
        </div>
    </ng-container>
  </div>
</div>

<div class="modal-footer d-flex align-items-center justify-content-between">
  <p class="text-muted small m-0">
    Select which columns you want to display in the <strong>{{ name }}</strong>.
  </p>
  <div class="d-flex align-items-center gap-2">
    <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button class="btn btn-primary" (click)="save()">Apply</button>
  </div>
</div>